import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {ProductInterface} from '../../products/interfaces/product.interface';

@Injectable({
  providedIn: 'root'
})
export class SearchFilterService {
  filterOpen = false;
  public searchActive$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public resetFilters$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public searchTerm$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public searchResults$: BehaviorSubject<ProductInterface[]> = new BehaviorSubject<ProductInterface[]>([]);
  public activateFilter$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() {
  }
}
